__turbopack_context__.v({
  "bubble": "agents-module__wHI0BG__bubble",
  "bubbleEnd": "agents-module__wHI0BG__bubbleEnd",
  "bubbleStart": "agents-module__wHI0BG__bubbleStart",
  "display": "agents-module__wHI0BG__display",
  "enter": "agents-module__wHI0BG__enter",
  "ep-bubble": "agents-module__wHI0BG__ep-bubble",
  "ep-dot": "agents-module__wHI0BG__ep-dot",
  "ep-float": "agents-module__wHI0BG__ep-float",
  "ep-rise": "agents-module__wHI0BG__ep-rise",
  "ep-signal": "agents-module__wHI0BG__ep-signal",
  "ep-ticker": "agents-module__wHI0BG__ep-ticker",
  "ep-typing": "agents-module__wHI0BG__ep-typing",
  "ep-wave": "agents-module__wHI0BG__ep-wave",
  "float": "agents-module__wHI0BG__float",
  "heroTitle": "agents-module__wHI0BG__heroTitle",
  "reveal": "agents-module__wHI0BG__reveal",
  "rv": "agents-module__wHI0BG__rv",
  "signal": "agents-module__wHI0BG__signal",
  "signalReverse": "agents-module__wHI0BG__signalReverse",
  "ticker": "agents-module__wHI0BG__ticker",
  "typing": "agents-module__wHI0BG__typing",
  "wave": "agents-module__wHI0BG__wave",
  "waveCenter": "agents-module__wHI0BG__waveCenter",
});
